(function () {
  var productPath = window.location.pathname || "";
  if (!/^\/products\/deutsch-dt[mp]?/i.test(productPath)) return;

  var clips = [
    {
      role: "Steel 03 mounting clip option",
      title: "DEUSTCH 1027-003-1200 Steel 03 Mounting Clip",
      url: "/products/deustch-1027-003-1200-steel-03-clip",
      image: "https://cdn.shopify.com/s/files/1/0304/6745/7069/products/TEC-1027-003-1200_01.jpg?v=1589890991",
      sku: "TEC-1027-003-1200",
      price: "$5.99",
      stock: "Available",
      available: true,
      variantId: "34418287280173"
    },
    {
      role: "Steel 05 mounting clip option",
      title: "DEUTSCH 1027-005-1200 Steel 05 Mounting Clip",
      url: "/products/deutsch-1027-005-1200-steel-05-clip",
      image: "https://cdn.shopify.com/s/files/1/0304/6745/7069/products/TEC-1027-005-1200_01.jpg?v=1589891039",
      sku: "TEC-1027-005-1200",
      price: "$5.49",
      stock: "Contact us",
      available: false,
      variantId: "34418292228141"
    },
    {
      role: "Steel 08 mounting clip option",
      title: "DEUTSCH 1027-008-1200 Steel 08 Mounting Clip",
      url: "/products/deutsch-1027-008-1200-steel-08-clip",
      image: "https://cdn.shopify.com/s/files/1/0304/6745/7069/products/TEC-1027-008-1200_01.jpg?v=1589891041",
      sku: "TEC-1027-008-1200",
      price: "$3.69",
      stock: "Contact us",
      available: false,
      variantId: "34418292752429"
    }
  ];

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function cardHtml(clip) {
    var stockClass = clip.available ? "pu-related-card__stock" : "pu-related-card__stock pu-related-card__stock--contact";
    var form = clip.available
      ? '<form class="pu-related-card__cart" method="post" action="/cart/add"><input type="hidden" name="id" value="' + escapeHtml(clip.variantId) + '"><input type="hidden" name="quantity" value="1"><button class="pu-related-card__add" type="submit">Add to cart</button></form>'
      : "";
    return '<article class="pu-related-card pu-related-card--metal-clip" data-pu-metal-clip="' + escapeHtml(clip.sku) + '">' +
      '<a class="pu-related-card__media" href="' + escapeHtml(clip.url) + '" aria-label="' + escapeHtml(clip.title) + '">' +
      '<img src="' + escapeHtml(clip.image) + '" alt="' + escapeHtml(clip.title) + '" loading="lazy">' +
      '</a>' +
      '<div class="pu-related-card__body">' +
      '<span class="pu-related-card__role">' + escapeHtml(clip.role) + '</span>' +
      '<a class="pu-related-card__title" href="' + escapeHtml(clip.url) + '">' + escapeHtml(clip.title) + '</a>' +
      '<span class="pu-related-card__sku">SKU: ' + escapeHtml(clip.sku) + '</span>' +
      '<div class="pu-related-card__meta"><span class="pu-related-card__price">' + escapeHtml(clip.price) + '</span><span class="' + stockClass + '">' + escapeHtml(clip.stock) + '</span></div>' +
      form +
      '<a class="pu-related-card__cta" href="' + escapeHtml(clip.url) + '">View item</a>' +
      '</div>' +
      '</article>';
  }

  function addMetalClips() {
    var section = document.querySelector('.pu-compatible-group[aria-label="Connector accessories"]');
    if (!section || section.querySelector('[data-pu-metal-clip]')) return;
    var grid = section.querySelector(".pu-related-card-grid");
    if (!grid) return;
    grid.insertAdjacentHTML("beforeend", clips.map(cardHtml).join(""));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", addMetalClips);
  } else {
    addMetalClips();
  }
  setTimeout(addMetalClips, 1000);
})();
